<template>
    <!-- 导航 -->
    <NavBar :bgcolor="$newYearStyle ? '#DAADA4' : '#a4beda'">
        <template v-slot:title>
            <span class="nav-title">机构</span>
        </template>
    </NavBar>

    <div class="list-box">
        <div class="item" v-for="organization in organizations" :key="organization.id">
            <div class="author">
                <div class="info">
                    <img :src="organization.logo" alt="" />
                    <section>
                        <p class="ellipsis1">{{ organization.name }}</p>
                        <div class="num">
                            <span><strong>{{ organization.subscribers_count }}</strong> 人 关注</span>
                            <span><strong>{{ organization.products_count }}</strong> 个 原创</span>
                        </div>
                    </section>
                </div>
                <div class="attention-btn" @click="toggleSubscribe(organization.id)">
                    {{ subscribes.indexOf(organization.id) > -1 ? '取消关注' : '关注' }}
                </div>
            </div>
            <p class="synopsis ellipsis3">
                简介：{{ organization.introduce }}
            </p>
        </div>
    </div>
</template>

<script src="./Page.js"></script>

<style src="./Page.scss" lang="scss" scoped></style>